import { useEffect, useRef, useState } from "react";
import { Container, InputFieldWithIcon } from "../../utils/CustomComponents";
import { ReactComponent as Email } from "../../img/Section/Email.svg";
import { ReactComponent as Key } from "../../img/Section/Key.svg";
import gsap, { Expo } from "gsap";
import { useUser } from "../../utils/Contexts/Context";
import { useHistory } from "react-router";
function SignIn({ view_controller, setController }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const signIn = useRef();
    const h2 = useRef();
    const input = useRef();
    const button = useRef();
    const note = useRef();
    const { setUser } = useUser();
    const [TimeLine, setTimeLine] = useState(null);
    const history = useHistory();
    useEffect(() => {
        const signInanim = gsap.timeline({ paused: true });
        signInanim.from([h2.current, ...input.current.children, button.current, note.current], {
            autoAlpha: 0,
            y: 100,
            stagger: { each: 0.125 },
            ease: Expo.easeOut,
            duration: 2,
        });
        // Plays animation on mount
        signInanim.play();
        setTimeLine(signInanim);
    }, [view_controller]);

    async function submit(e) {
        e.preventDefault();
        // this just simulates submit operation,
        // it will always succed as there is not real authentication
        // const user = await signinWithEMailAndPassword(email, password)
        const demo_user = {
            id: 5,
            token: "",
            // could have used a better flag
            // mode just tells me if
            // its a company thats signed in
            // or an individual.
            // individual in this case, company
            name: "John",
            mode: "company",
            other_data: {
                language: "en",
            },
        };
        setUser(demo_user);
        history.push("/dashboard");
    }
    return (
        <div className="sign_in" ref={signIn}>
            <Container>
                <form onSubmit={submit}>
                    <h2 ref={h2}>sign in</h2>
                    <div ref={input} className="form_group">
                        <InputFieldWithIcon
                            placeholder="email"
                            icon={<Email fontSize={20} />}
                            padding={15}
                            name="sign_in_email"
                            setValue={setEmail}
                            type="email"
                            value={email}
                        />
                        <InputFieldWithIcon
                            placeholder="password"
                            icon={<Key fontSize={20} />}
                            padding={15}
                            name="sign_in_password"
                            setValue={setPassword}
                            type="password"
                            value={password}
                        />
                    </div>
                    <button type="submit" className="btn_pry" ref={button}>
                        sign in
                    </button>
                </form>
                <div className="note" ref={note}>
                    Don’t have an account yet?{" "}
                    <span
                        onClick={() => {
                            // Reeverses the animation
                            TimeLine.timeScale(3);
                            TimeLine.reverse();
                            // waits 1 second so reverse animation completes, then changes the view
                            setTimeout(() => {
                                setController("sign_up");
                            }, 1000);
                        }}
                    >
                        Sign up
                    </span>
                </div>
            </Container>
        </div>
    );
}

export default SignIn;
